<template>
  <QuestionBase :errors="[...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputRadio ref="input"
                v-model="data"
                :args="args"
                :db="db"
                :disabled="!!liabilities.length"
                :no-save="false"
                :options="booleanYesNo"
                :server-errors="serverErrors"
                @jsErrors="jsErrors=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {general} from "../../../options/general";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'LiabilitiesOtherYN',
  mixins: [
    general,
    questionLoadHelpers
  ],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    liabilities: {
      type: Array,
      required: true
    }
  },
  mounted() {
    // set initial question value (yes/no) based on assets
    if (this.liabilities.length && !this.data) {
      this.$refs.input.data = true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'Do you have any other credit agreements?',
        subTitle: 'This could include student loans or debts to family members for example.',
        tip: null,
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'other_credit_agreements'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>